/* NELEBA – scripts propios para Dawn (no derivados de Shrine). */
(function () {
  'use strict';

  var STORAGE_KEY = 'neleba-cart-timer-end';
  var memoryEnd = 0; // respaldo si sessionStorage no está disponible

  function readEnd() {
    try {
      var stored = parseInt(window.sessionStorage.getItem(STORAGE_KEY), 10);
      if (stored) return stored;
    } catch (e) { /* almacenamiento no disponible */ }
    return memoryEnd;
  }
  function writeEnd(value) {
    memoryEnd = value;
    try { window.sessionStorage.setItem(STORAGE_KEY, String(value)); } catch (e) { /* almacenamiento no disponible */ }
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  if (!customElements.get('neleba-cart-timer')) {
    customElements.define('neleba-cart-timer', class extends HTMLElement {
      connectedCallback() {
        this.clock = this.querySelector('[data-neleba-timer]');
        this.durationMs = (parseInt(this.dataset.minutes, 10) || 5) * 60 * 1000;
        if (!this.clock) return;
        this.tick = this.tick.bind(this);
        this.tick();
        this.interval = window.setInterval(this.tick, 1000);
      }
      disconnectedCallback() {
        window.clearInterval(this.interval);
      }
      tick() {
        var now = Date.now();
        var end = readEnd();
        // Si no hay cuenta atrás o ha terminado, empieza una nueva.
        if (!end || end <= now || end - now > this.durationMs) {
          end = now + this.durationMs;
          writeEnd(end);
        }
        var remaining = Math.max(0, Math.round((end - now) / 1000));
        this.clock.textContent = pad(Math.floor(remaining / 60)) + ':' + pad(remaining % 60);
      }
    });
  }

  function initScrollTop() {
    var btn = document.querySelector('[data-neleba-scroll-top]');
    if (!btn) return;
    var threshold = parseInt(btn.dataset.after, 10) || 400;
    var ticking = false;
    function update() {
      btn.classList.toggle('is-visible', window.scrollY > threshold);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    btn.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollTop);
  } else {
    initScrollTop();
  }
})();
